import axios from '@/utils/api'

const actions = {
  async getPrazoNotificacaoByTipo ({commit}, tipo) {
    const response = await axios({
      method: 'POST',
      url: `prazoNotificacao/${tipo}`
    })
    return response
  }
}

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/analise/prazoNotificacao.js